import type {LayoutRowPartWidth} from 'shared/layouts/grid-system/built-layout/types';
import {getContext, hasContext, setContext} from 'svelte';

export const gridSystemContextKey = 'grid-system-ctx';
export const gridSystemRowContextKey = 'grid-system-row-ctx';

export interface GridSystemContext {
    rowWidth: LayoutRowPartWidth;
}

export interface GridSystemRowContext {
    columnsCount: number;
}

export function createGridSystemContext(rowWidth: LayoutRowPartWidth): GridSystemContext {
    return setContext<GridSystemContext>(gridSystemContextKey, {
        rowWidth
    });
}

export function getGridSystemContext(): GridSystemContext {
    if (!hasContext(gridSystemContextKey)) {
        throw new Error('Grid system context does not exist! Use `createGridSystemContext` function to create it in a parent component.');
    }

    return getContext<GridSystemContext>(gridSystemContextKey);
}

export function createGridSystemRowContext(columnRatios: number[]): GridSystemRowContext {
    if (!hasContext(gridSystemContextKey)) {
        throw new Error('You can only create Row Grid context in Grid System context, but it does not exist! Use `createGridSystemContext` function to create it in a parent component.');
    }

    return setContext<GridSystemRowContext>(gridSystemRowContextKey, {
        columnsCount: columnRatios.length
    });
}

export function getGridSystemRowContext(): GridSystemRowContext {
    if (!hasContext(gridSystemContextKey)) {
        throw new Error('Grid Row context does not exist! Use `createGridSystemRowContext` function to create it in a parent component.');
    }

    return getContext<GridSystemRowContext>(gridSystemContextKey);
}
